@if ((isTranslationsLoading$ | async) === false) {
<div class="flex flex-row">
  <mic-sidebar-container class="h-full" leftToggler="white-sidebar">
    @if (!router.url.includes('/home/changepassword')) {
    <mic-sidebar position="start" mode="large">
      <mic-sidebar-item
        #sidebarItem
        label="{{ this.translationService.translate('homeText') }}"
        link="/home/dashboard"
        icon="home"
        class="main-label"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="onSidebarItemClick($event)"
      >
      </mic-sidebar-item>
      @if (isWorkOrderEnabled && this.checkTokenForAuthority(ROLES.search)) {
      <mic-sidebar-item
        #sidebarItem
        label="{{ this.translationService.translate('searchCasingsText') }}"
        link="/home/search-casings"
        icon="search"
        class="main-label"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="onSidebarItemClick($event)"
      >
      </mic-sidebar-item>
      }
      <!-- TODO: Add new translation -->
      @if (isWorkOrderEnabled && this.canViewWorkOrders()) {
      <mic-sidebar-item
        #sidebarItem
        link="/home/work-orders"
        label="{{ translationService.translate('workOrdersText') }}"
        icon="assignment"
        class="main-label"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="onWOSidebarItemClick('/home/work-orders')"
      >
        <!-- TODO: Create this route/page -->
      </mic-sidebar-item>
      }@if (this.checkTokenForAuthority(ROLES.search)) {
      <mic-sidebar-item
        #sidebarItem
        link="/home/packlists"
        label="{{ translationService.translate('packListsText') }}"
        icon="local_shipping"
        class="main-label"
        (click)="onSidebarItemClick($event)"
      >
      </mic-sidebar-item>
      } @if (!isUserMgmtEnabled || this.checkTokenForAuthority(ROLES.view_cams) || this.checkTokenForAuthority(ROLES.edit_cams)) {
      <mic-sidebar-item
        #sidebarItem
        link="/home/specifications"
        label="{{ this.translationService.translate('camSpecsText') }}"
        icon="tire_repair"
        class="main-label"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="onSidebarItemClick($event)"
      >
      </mic-sidebar-item>
      }
      <!-- Prod-customer-enable -->
      @if ( !isUserMgmtEnabled || this.checkTokenForAuthority(ROLES.view_customer) || this.checkTokenForAuthority(ROLES.edit_customer) ) {
      <mic-sidebar-item
        #sidebarItem
        link="/home/customers"
        label="{{ this.translationService.translate('customersText') }}"
        icon="person"
        class="main-label"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="onSidebarItemClick($event, '/home/customers')"
      >
      </mic-sidebar-item>
      } @if (this.checkTokenForAuthority(ROLES.view_product)) {
      <mic-sidebar-item
        #sidebarItem
        link="/home/productData"
        label="{{ this.translationService.translate('productDataText') }}"
        class="main-label"
        icon="circle"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="onSidebarItemClick($event, '/home/productData')"
      >
      </mic-sidebar-item>

      } @if (this.checkTokenForAuthority(ROLES.inventory_role)) {

      <mic-sidebar-item
        #sidebarItem
        link="/home/inventory"
        label="{{ this.translationService.translate('inventoryText') }}"
        icon="inventory"
        class="main-label"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="onSidebarItemClick($event)"
      >
      </mic-sidebar-item>
      } @if (isAuditLogsScreenEnabled && this.checkTokenForAuthority(ROLES.view_log)) {
      <mic-sidebar-item
        #sidebarItem
        link="/home/logs"
        label="{{ this.translationService.translate('LogsText') }}"
        icon="person"
        class="main-label"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="onSidebarItemClick($event)"
      >
      </mic-sidebar-item>
      } @if ( this.checkTokenForAuthority(ROLES.btn_admin) || this.checkTokenForAuthority(ROLES.plant_view) ||
      this.checkTokenForAuthority(ROLES.edit_product) || this.checkTokenForAuthority(ROLES.site_view) || this.canEditDealerSetup() ||
      this.canViewPosInterface() || this.canViewEmailSetup || this.hasRolePermission(ROLES.view_user) ||
      this.checkTokenForAuthority(ROLES.view_zone )) {
      <mic-sidebar-item
        #sidebarItem
        link="/home/setup"
        label="{{ this.translationService.translate('setupText') }}"
        class="main-label"
        icon="settings"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="onSidebarItemClick($event, '/home/setup')"
      >
      </mic-sidebar-item>
      } @if ((this.hasRolePermission(ROLES.btn_admin) || this.hasRolePermission(ROLES.dataset_download)) && isDatasetDownloadEnabled) {
      <mic-sidebar-item
        #sidebarItem
        link="/home/datasetDownload"
        label="{{ translationService.translate('datasetDownloadText') }}"
        icon="download_for_offline"
        class="main-label"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="onSidebarItemClick($event)"
      >
      </mic-sidebar-item>
      } @if (this.checkTokenForAuthority(ROLES.btn_admin)) {
      <mic-sidebar-item
        #sidebarItem
        link="/home/administration"
        label="Administration"
        icon="admin_panel_settings"
        class="main-label"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="onSidebarItemClick($event)"
      >
      </mic-sidebar-item>
      } @if (isUserManualEnabled) {
      <mic-sidebar-item
        #sidebarItem
        (click)="openUserManual(); onSidebarItemClick($event)"
        label="User Manual"
        icon="menu_book"
        class="main-label"
        matTooltip="Click to open comprehensive user documentation"
        matTooltipPosition="right"
      >
      </mic-sidebar-item>
      }
      <mic-sidebar-item
        #sidebarItem
        link="/home/help/accessibility-statement"
        label="{{ translationService.translate('helpText') }}"
        icon="help_outline"
        class="main-label"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="onSidebarItemClick($event)"
      >
      </mic-sidebar-item>
      @if (isLaoMenuVisible) {
      <mic-sidebar-item
        #sidebarItem
        label="LAO"
        icon="language"
        class="main-label"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="openLaoApp(); onSidebarItemClick($event)"
      >
      </mic-sidebar-item>
      }
      <mic-sidebar-spacer></mic-sidebar-spacer>
      @if (isLegacyButtonVisible) {
      <mic-sidebar-item
        #sidebarItem
        label="{{ this.translationService.translate('legacyVersionLabel') }}"
        class="mic-sidebar-nav-old"
        [ngClass]="{ 'disable-sidebar': editMode === true }"
        (click)="openLegacyBtn(); onSidebarItemClick($event)"
        matTooltip="{{ dealerUrl ? dealerUrl + 'gra/jsp/common/home.faces' : '' }}"
        matTooltipClass="nav-old-tooltip"
        matTooltipPosition="above"
        matTooltipShowDelay="500"
      />
      }
    </mic-sidebar>
    }
    <mic-main-content main>
      <div #mainContentArea class="flex flex-col fill justify-between" content>
        <div #scrollAnchor style="height: 0; overflow: hidden" aria-hidden="true"></div>
        <div class="sidebar-container-content main-layout-card">
          <router-outlet></router-outlet>
        </div>
      </div>
    </mic-main-content>
  </mic-sidebar-container>
</div>
}
